
import Image from "next/image";
import styles from "./ediror.module.scss";
import { HandySvg } from "handy-svg";
import { useEffect, useState } from "react";
import { updatePersonData,  getPerson } from "../../../pages/api/sportcards";
import { useStore } from "../../../stores/use_global_state";

const Download = ({ sportCardsState, openFolder, setOpenFolder }) => {
  const folders = sportCardsState.person.cards;
  const { state } = useStore();
  let token = state?.userInfo?.token ? state.userInfo.token : false;
  const [email, setEmail] = useState("");
  const [personData, setPersonData] = useState(null);
  const [emailIsSend, setEmailIsSend] = useState(false);

  useEffect(() => {
    const getPersonData = async () => {
      const { data } = await getPerson(sportCardsState?.person?.id, token);

      setPersonData(data)
      setEmail(data?.email || "")
    }

    getPersonData()
  }, []);

  const setEmailHandler = async () => {
    if (email !== personData.email) {
      const { data } = await updatePersonData(personData?.id, { email }, token);
      setPersonData(data)
    }

    setEmailIsSend(true)
  }

  const openFolderHandler = (folder) => {
    setOpenFolder(folder);
  }

  return <>
    {openFolder === null && <div className={`${styles.download} ${!emailIsSend ? styles.bg : ""}`}>
      {personData !== null && <div className={styles.downloadInfo}>
        <div className={styles.downloadContent}>
          {!emailIsSend && <>
            <h4 className={styles.downloadTitle}>We create a unique model for every person. It usually takes about 30 minutes</h4>
            <p className={styles.downloadText}>We will send you a notification about the readiness to your email</p>
            <div className={styles.downloadInput}>
              <input type="text" name="name" id="" value={email} onChange={(e) => setEmail(e.target.value)} />
              <button onClick={setEmailHandler} aria-label="create new percon" disabled={email.length < 1}><HandySvg src={"/sport_cards/done.svg"} width={16} height={16} className={`${open ? styles.open : ""}`} fill={"transparent"} /></button>
            </div>
          </>}
          {emailIsSend &&
            <>
              <h4 className={styles.downloadTitle}>Thank you!</h4>
              <p className={styles.downloadText}>We will send you a notification to <span>{email}</span></p>
            </>
          }
        </div>

      </div>}

    </div>}
    {
      folders.length > 0 && openFolder === null &&
      <div className={styles.foldersWrapper}>
        {folders.map(
          (folder) => {
            const folderNotReady = folder.variants.some(item => item.status !== "READY")

            return (
              <button onClick={() => openFolderHandler(folder)} key={folder.id} className={styles.folder} disabled={folderNotReady}>
                <div className={styles.folderContent}>
                  <Image src={folder.variants?.[0].url || "/illustration_service/mountains_loader.gif"} alt="pose" width="100" height="80" quality={99} unoptimized />
                  {folderNotReady && <spna>Wait...</spna>}
                </div>
              </button>
            )
          }
        )}
      </div>
    }
    {folders.length > 0 && openFolder !== null &&
      <div className={styles.foldersWrapper}>
        {openFolder.variants.map((variant) =>
          <a href={variant.url} target="_blank" key={variant.id} className={styles.variant} rel="noreferrer" >
            <Image src={variant.url} alt="pose" width="218" height="305" quality={99} unoptimized />
          </a>)
        }
      </div>
    }
  </>
}

export default Download